// @flow
export { default } from './LabelInput';



// WEBPACK FOOTER //
// ./src/components/register/LabelInput/index.js